import { createAsyncThunk } from '@reduxjs/toolkit';
import { PdfSummarizationAPI } from '../../helpers/firebase_helper';

// Thunk 1: Request pre-signed URL from backend
export const requestPresignedUrl = createAsyncThunk(
  'pdf/requestPresignedUrl',
  async ({ fileName, fileType, fileSize }, { rejectWithValue }) => {
    try {
      const result = await PdfSummarizationAPI.requestPresignedUrl(
        fileName,
        fileType,
        fileSize
      );
      return result;
    } catch (error) {
      console.log(error);
      
      return rejectWithValue(
        error.response?.data?.message || 'Failed to get upload URL'
      );
    }
  }
);

// Thunk 2: Upload file to S3 using pre-signed URL
export const uploadFileToS3 = createAsyncThunk(
  'pdf/uploadFileToS3',
  async ({ file, preSignedUrl }, { rejectWithValue, dispatch }) => {
    try {
      const result = await PdfSummarizationAPI.uploadToS3(
        preSignedUrl,
        file,
        (progressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          dispatch({ type: 'pdf/uploadProgress', payload: progress });
        }
      );
      return result;
    } catch (error) {
      console.log(error);
      
      return rejectWithValue(
        error.response?.data?.message || 'Failed to upload file to S3'
      );
    }
  }
);

// Thunk 3: Poll processing status
export const pollProcessingStatus = createAsyncThunk(
  'pdf/pollProcessingStatus',
  async ({ correlationId }, { rejectWithValue }) => {
    try {
      const result = await PdfSummarizationAPI.getProcessingStatus(
        correlationId
      );
      return result;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch processing status'
      );
    }
  }
);

// Thunk 4: Fetch AI summary
export const fetchAISummary = createAsyncThunk(
  'pdf/fetchAISummary',
  async ({ correlationId }, { rejectWithValue }) => {
    try {
      const result = await PdfSummarizationAPI.fetchSummary(correlationId);
      return result;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch AI summary'
      );
    }
  }
);

// Thunk 5: Fetch all uploaded files
export const fetchUploadedFiles = createAsyncThunk(
  'pdf/fetchUploadedFiles',
  async ({itemsPerPage, offset}, { rejectWithValue }) => {
   
    try {
      const files = await PdfSummarizationAPI.getAllFiles(itemsPerPage, offset);
      return files;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch uploaded files'
      );
    }
  }
);

// Thunk 6: Delete file
export const deleteFile = createAsyncThunk(
  'pdf/deleteFile',
  async (data, { rejectWithValue }) => {
    try {
      const result = await PdfSummarizationAPI.deleteFile(data);
      return result;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to delete file'
      );
    }
  }
);

// Thunk 7: Download file
export const downloadFile = createAsyncThunk(
  'pdf/downloadFile',
  async ({ fileId, fileName }, { rejectWithValue }) => {
    try {
      const blob = await PdfSummarizationAPI.downloadFile(fileId);
      
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return { fileId };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to download file'
      );
    }
  }
);

// Thunk 8: Get download URL (alternative approach)
export const getDownloadUrl = createAsyncThunk(
  'pdf/getDownloadUrl',
  async ({ fileId }, { rejectWithValue }) => {
    try {
      const downloadUrl = await PdfSummarizationAPI.getDownloadUrl(fileId);
      return { fileId, downloadUrl };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to get download URL'
      );
    }
  }
);
